module.exports = __webpack_public_path__ + "img/challenges.c39e2da6.svg";